export default "__VITE_ASSET__Dmh9XK7T__"